import { render, staticRenderFns } from "./list-item-file.vue?vue&type=template&id=07434d40&"
import script from "./list-item-file.vue?vue&type=script&lang=js&"
export * from "./list-item-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports